// extracted by mini-css-extract-plugin
module.exports = {"title":"CardFrame_title__3tqV9","subtitle":"CardFrame_subtitle__1A1do","description":"CardFrame_description__2a0h9","frame":"CardFrame_frame__puPkb"};